import React, { Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';

// Lazy so the bot's code is only fetched on pages that show it.
const TsgAiBot = lazy(() => import('./TsgAiBot'));

/**
 * Tee Gee shows broadly — home, login, register, student & builder dashboards,
 * and most product pages — so visitors and users can always reach it from a
 * corner of the page.
 *
 * It is hidden only where a floating lead-gen chat clearly does not belong:
 *   • the back-office admin / super-admin / CRM consoles, and
 *   • the two FULL-SCREEN in-app chat surfaces (the AI Tutor and TSG notes),
 *     where a second floating chat would collide with the existing one.
 *
 * Deny-list, so any new page gets the bot automatically.
 */
const HIDDEN_PREFIXES = [
  '/superadmin',
  '/admin-console',
  '/admin',                       // admin back-office (incl. /admin/login)
  '/nextgen-builder/ai-tutor',    // full-screen AI Tutor chat
  '/student/tsg',                 // TSG notes / tutor surface
  '/chatbot',                     // legacy student tutor route
];

const isHidden = (pathname) =>
  HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + '/'));

export default function TsgAiBotGate() {
  const { pathname } = useLocation();
  if (isHidden(pathname)) return null;
  return (
    <Suspense fallback={null}>
      <TsgAiBot />
    </Suspense>
  );
}

export { isHidden, HIDDEN_PREFIXES };
